/**
 * Waepa Frontend Scripts
 *
 * Main frontend entry point that creates the window.wdg namespace.
 * View scripts from blocks will populate wdg.blocks.* automatically.
 *
 * @since 1.0.0
 */

// Create window.wdg namespace if it doesn't exist
window.wdg = window.wdg || {};
window.wdg.blocks = window.wdg.blocks || {};

/**
 * Initialize waepa frontend
 *
 * Runs after DOM is loaded. Add any frontend initialization logic here.
 *
 * @since 1.0.0
 */
const init = () => {
	// Frontend initialization complete
	if ( window.console && window.console.log ) {
		console.log( 'Waepa frontend scripts loaded' );
	}
};

// Auto-initialize on DOMContentLoaded
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
